import {globalSlice, callTypes} from './Slice';
//import * as signalR from '@microsoft/signalr';
import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr';
const {actions} = globalSlice;

export const setRandom = () => (dispatch) => {
  dispatch(actions.setRandom());
};

export const setBranches = (data) => (dispatch) => {
  dispatch(actions.setBranches(data));
};

export const setCurrentBranch = (data) => (dispatch) => {
  dispatch(actions.setCurrentBranch(data));
};
export const setChooseBranch = (data) => (dispatch) => {
  dispatch(actions.setChooseBranch(data));
};
export const setNameParent = (data) => (dispatch) => {
  dispatch(actions.setNameParent(data));
};

export const listenNotifications = (accessToken) => async (dispatch) => {
  console.log('listenNotifications');
  const connection = new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_URL}/notifications`, {
      //.withUrl(`http://192.168.2.136:5000/notifications`, {
      headers: {tenant: 'root'},
      accessTokenFactory: () => `${accessToken}`,
    })
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) => {
        if (retryContext.elapsedMilliseconds < 60000) {
          return Math.random() * 10000;
        } else {
          return null;
        }
      },
    })
    .build();
  dispatch(actions.setConnection(connection));

  if (connection) {
    connection.start().then((e) => {
      console.log('SocketConnected!');
      connection.on('NotificationFromServer', (message, message2) => {
        console.log('NotificationFromServerNotificationFromServer');
        console.log(message);
        console.log(message2);
        dispatch(actions.setNameParent(message2));

        //dispatch(actions.setConnection(connection));
      });
      // connection.on('ReceiveMessage', (message, message2) => {
      //   console.log('ReceiveMessageReceiveMessage');
      //   console.log(message);
      //   dispatch(actions.setNameParent(message2));

      //   console.log(message2);
      // });
    });
  }
};
